<template>
  <div>
    <template v-if="!visible">
      <slot />
    </template>
    <template v-else>
      <div class="license-wrapper">
        <!-- Conteúdo fake -->
        <div class="fake-content">
          <div class="fake-toolbar">
            <div class="fake-button"></div>
            <div class="fake-filter" style="width: 160px"></div>
            <div class="fake-filter" style="width: 120px"></div>
            <div class="fake-filter" style="width: 180px"></div>
          </div>

          <div class="fake-grid">
            <div class="fake-card" v-for="i in 3" :key="'card-'+i">
              <div class="fake-card-header"></div>
            </div>
          </div>

          <div class="fake-rows">
            <div
              class="fake-row"
              v-for="i in 5"
              :key="'row-'+i"
              :style="{ opacity: 1 - (i - 1) * 0.12 }"
            ></div>
          </div>
        </div>

        <!-- Overlay -->
        <div class="license-overlay">
          <div class="license-overlay__backdrop"></div>
          <div class="license-overlay__card">
            <div class="license-overlay__icon">
              <fa-icon icon="lock" />
            </div>
            <h3 class="license-overlay__title">Recurso requer licença</h3>
            <p class="license-overlay__message">
              Este módulo requer uma licença ativa para utilização.
            </p>
            <div class="license-overlay__sistemas" v-if="sistemasFaltantes.length > 0">
              <span class="license-overlay__sistemas-label">Requer licença de ao menos um dos sistemas:</span>
              <div class="license-overlay__tags">
                <span
                  v-for="sistema in sistemasFaltantes"
                  :key="sistema"
                  class="license-overlay__tag"
                >
                  {{ sistema }}
                </span>
              </div>
            </div>
            <p class="license-overlay__contact">
              Entre em contato com o time comercial para adquirir a licença.
            </p>
            <a
              :href="whatsappLink"
              target="_blank"
              rel="noopener noreferrer"
              class="license-overlay__whatsapp"
            >
              <fa-icon :icon="['fab', 'whatsapp']" />
              Falar com o comercial
            </a>
          </div>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import sidebarMenus, { getSistemasParaRota, NOMES_SISTEMAS } from "../../config/sideBar";

export default {
  name: "LicenseOverlay",
  props: {
    licencasSistemas: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    sistemasNecessarios() {
      return getSistemasParaRota(this.$route.path);
    },
    visible() {
      if (!this.sistemasNecessarios || !this.licencasSistemas) return false;
      return !this.sistemasNecessarios.some(s => this.licencasSistemas[s]);
    },
    sistemasFaltantes() {
      if (!this.sistemasNecessarios) return [];
      return this.sistemasNecessarios
        .filter(s => !this.licencasSistemas[s])
        .map(s => NOMES_SISTEMAS[s] || s);
    },
    nomeModulo() {
      const path = this.$route.path;
      for (const menu of sidebarMenus) {
        for (const item of (menu.children || [])) {
          if (item.href === path) {
            return item.modulo.replace('ADMIN_', '').replace(/_/g, ' ');
          }
        }
      }
      return '';
    },
    whatsappLink() {
      const fone = '5551984568586';
      const modulo = this.nomeModulo || 'este módulo';
      const msg = encodeURIComponent(`Olá, tudo bem? Tenho interesse em conhecer mais sobre o módulo ${modulo}`);
      return `https://wa.me/${fone}?text=${msg}`;
    },
  },
};
</script>

<style scoped>
.license-wrapper {
  position: relative;
  min-height: calc(100vh - 200px);
}

/* Fake content */
.fake-content {
  padding: 20px;
  pointer-events: none;
  user-select: none;
}

.fake-toolbar {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 24px;
}

.fake-button {
  width: 140px;
  height: 36px;
  border-radius: 6px;
  background: linear-gradient(135deg, #3a3e81, #4a4f9a);
  flex-shrink: 0;
}

.fake-filter {
  height: 36px;
  border-radius: 6px;
  background: #f0f0f5;
  border: 1px solid #e4e4eb;
  flex-shrink: 0;
}

.fake-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 16px;
  margin-bottom: 24px;
}

.fake-card {
  height: 120px;
  border-radius: 10px;
  border: 1px solid #e8e8ef;
  overflow: hidden;
  position: relative;
}

.fake-card::after {
  content: "";
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(90deg, transparent, rgba(58,62,129,0.04), transparent);
  animation: shimmer 2s infinite;
}

.fake-card-header {
  height: 40px;
  background: #f5f5fa;
  border-bottom: 1px solid #e8e8ef;
}

.fake-rows {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.fake-row {
  height: 44px;
  border-radius: 8px;
  background: #fafafc;
  border: 1px solid #ededf3;
  position: relative;
  overflow: hidden;
}

.fake-row::after {
  content: "";
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(90deg, transparent, rgba(58,62,129,0.03), transparent);
  animation: shimmer 2.5s infinite;
}

@keyframes shimmer {
  0% { left: -100%; }
  100% { left: 100%; }
}

/* Overlay */
.license-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 100;
  display: flex;
  align-items: center;
  justify-content: center;
}

.license-overlay__backdrop {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  backdrop-filter: blur(6px);
  -webkit-backdrop-filter: blur(6px);
  background: rgba(255, 255, 255, 0.45);
}

.license-overlay__card {
  position: relative;
  z-index: 1;
  background: rgba(255, 255, 255, 0.85);
  backdrop-filter: blur(16px);
  -webkit-backdrop-filter: blur(16px);
  border: 1px solid rgba(58, 62, 129, 0.15);
  border-radius: 16px;
  padding: 40px 48px;
  max-width: 480px;
  text-align: center;
  box-shadow:
    0 8px 32px rgba(58, 62, 129, 0.12),
    0 2px 8px rgba(0, 0, 0, 0.06);
}

.license-overlay__icon {
  width: 64px;
  height: 64px;
  border-radius: 50%;
  background: linear-gradient(135deg, #3a3e81, #2298a3);
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 20px;
  color: #fff;
  font-size: 24px;
}

.license-overlay__title {
  font-size: 20px;
  font-weight: 600;
  color: #3a3e81;
  margin-bottom: 8px;
}

.license-overlay__message {
  font-size: 14px;
  color: #636578;
  margin-bottom: 16px;
  line-height: 1.5;
}

.license-overlay__sistemas {
  margin-bottom: 16px;
}

.license-overlay__sistemas-label {
  display: block;
  font-size: 12px;
  font-weight: 600;
  color: #8b8da0;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  margin-bottom: 8px;
}

.license-overlay__tags {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 6px;
}

.license-overlay__tag {
  display: inline-block;
  padding: 4px 12px;
  border-radius: 20px;
  background: #eceaf3;
  color: #3a3e81;
  font-size: 13px;
  font-weight: 500;
  border: 1px solid #dddce9;
}

.license-overlay__contact {
  font-size: 13px;
  color: #8b8da0;
  margin-bottom: 16px;
}

.license-overlay__whatsapp {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 10px 24px;
  border-radius: 8px;
  background: #25d366;
  color: #fff;
  font-size: 14px;
  font-weight: 600;
  text-decoration: none;
  transition: background 0.2s;
}

.license-overlay__whatsapp:hover {
  background: #1ebe57;
  color: #fff;
  text-decoration: none;
}
</style>
